// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabPage .tabs-wrapper {
  padding: 16px 0 4px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.TabPage .tabs-container {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  background: var(--base_color2);
}
.TabPage .tabs-container .tab-header-lock {
  display: flex;
  align-items: center;
  margin-top: 1px;
}
.TabPage .tabs-container .tab-header-lock-icon {
  width: 20px;
  height: 20px;
  margin-bottom: 1px;
  margin-right: 1px;
}
.TabPage .tabs-container .tab-header-lock-title {
  font-size: 14px;
}
.TabPage .tabs-container .notAllowed + .notAllowed {
  margin-left: 32px;
}
.TabPage .tabs-container .tab-link {
  display: flex;
  align-items: center;
  color: var(--gray);
}
.TabPage .tabs-container .tab-link + .tab-link,
.TabPage .tabs-container .tab-link + .notAllowed {
  margin-left: 32px;
}
.TabPage .tabs-container .tab-link::after {
  position: absolute;
  content: "";
  left: 0;
  top: calc(100% + 2px);
  width: 0;
  height: 2px;
  background: currentColor;
  transition: width 200ms;
  transition-delay: 200ms;
}
.TabPage .tabs-container .tab-link.active {
  position: relative;
  color: var(--color_primary_500);
}
.TabPage .tabs-container .tab-link.active::after {
  width: 32px;
}
.TabPage .tabs-container .tab-link.active .fake-header-lock-icon path {
  stroke: var(--color_primary_500);
}
@media (max-width: 428px) {
  .TabPage .tabs-container {
    overflow-x: scroll;
    scrollbar-width: none;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
  }
  .TabPage .tabs-container .tooltipped-multiline::after,
  .TabPage .tabs-container .tooltipped-multiline::before {
    display: none;
  }
}
.TabPage .tabs-container::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/RouterTabs/index.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADR;AAIM;EACE,eAAA;AAFR;AAMI;EACE,iBAAA;AAJN;AAOI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AALN;AAOM;;EAEE,iBAAA;AALR;AAQM;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,uBAAA;AANR;AASM;EACE,kBAAA;EACA,+BAAA;AAPR;AASQ;EACE,WAAA;AAPV;AAWU;EACE,gCAAA;AATZ;AAeI;EAnEF;IAoEI,kBAAA;IACA,qBAAA;IACA,8BAAA;IACA,wBAAA;EAZJ;EAcI;;IAEE,aAAA;EAZN;AACF;AAeI;EACE,aAAA;AAbN","sourcesContent":[".TabPage {\n  .tabs-wrapper {\n    padding: 16px 0 4px;\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .tabs-container {\n    display: flex;\n    align-items: center;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 18px;\n    background: var(--base_color2);\n\n    .tab-header-lock {\n      display: flex;\n      align-items: center;\n      margin-top: 1px;\n\n      &-icon {\n        width: 20px;\n        height: 20px;\n        margin-bottom: 1px;\n        margin-right: 1px;\n      }\n\n      &-title {\n        font-size: 14px;\n      }\n    }\n\n    .notAllowed+.notAllowed {\n      margin-left: 32px;\n    }\n\n    .tab-link {\n      display: flex;\n      align-items: center;\n      color: var(--gray);\n\n      +.tab-link,\n      +.notAllowed {\n        margin-left: 32px;\n      }\n\n      &::after {\n        position: absolute;\n        content: '';\n        left: 0;\n        top: calc(100% + 2px);\n        width: 0;\n        height: 2px;\n        background: currentColor;\n        transition: width 200ms;\n        transition-delay: 200ms;\n      }\n\n      &.active {\n        position: relative;\n        color: var(--color_primary_500);\n\n        &::after {\n          width: 32px;\n        }\n\n        .fake-header-lock-icon {\n          path {\n            stroke: var(--color_primary_500);\n          }\n        }\n      }\n    }\n\n    @media (max-width: 428px) {\n      overflow-x: scroll;\n      scrollbar-width: none;\n      overflow: -moz-scrollbars-none;\n      -ms-overflow-style: none;\n\n      .tooltipped-multiline::after,\n      .tooltipped-multiline::before {\n        display: none;\n      }\n    }\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
